import React from 'react';

import clsx from 'clsx';
import {CheckSharp} from '@material-ui/icons';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import {Box, FormControlLabel, FormGroup, Grid, IconButton, Typography} from '@material-ui/core';

import {AppBarStyles} from 'assets/tss/commons';
import {BeneficiaryInfo} from 'commons/types/Types';
import {MainContent} from 'layouts/commons';
import {useButtonStyles} from 'assets/tss/layouts/components';
import {Messages} from 'commons/constants';
import {EfeAccordion, EfeCheckbox} from 'components';

type Props = {
    isLoading: boolean;
    authorization: boolean;
    percentageCompleted: number;
    beneficiaries: Array<BeneficiaryInfo>;
    handleChange: (kycIdSelected: number) => void;
    handleDelete: (kycId: number, name: string) => void;
    handleAuthorization: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

function BeneficiaryHeader(props: Props) {
    const classes = AppBarStyles();
    const buttonStyles = useButtonStyles();

    const {
        isLoading,
        authorization,
        percentageCompleted,
        beneficiaries,
        handleChange,
        handleDelete,
        handleAuthorization,
    } = props;

    const AuthorizationCheck = (
        <>
            {!isLoading && (
                <FormGroup>
                    <FormControlLabel
                        control={
                            <EfeCheckbox
                                name='authorization'
                                id='authorization'
                                onChange={handleAuthorization}
                                checked={authorization}
                            />
                        }
                        label={
                            <Typography variant='body2' color='textPrimary'>
                                {Messages.CLIENT_AUTHORIZATION_BENEFICIARIES}
                            </Typography>
                        }
                    />
                </FormGroup>
            )}
        </>
    );

    return (
        <MainContent>
            <Grid container direction='row' justifyContent='space-between' spacing={5}>
                <Grid item xs={12}>
                    <Box color='text.primary'>
                        <Typography variant='body2' color='textPrimary'>
                            <p>{Messages.BENEFICIARIES_CAPTURE_THE_WHOLE_PERCENTAGE}</p>
                            <p>{Messages.BENEFICIARIES_HEADER}</p>
                        </Typography>
                    </Box>
                </Grid>
                {beneficiaries && beneficiaries.length > 0 && (
                    <>
                        <Grid
                            item
                            xs={12}
                            className={clsx(
                                percentageCompleted === 100
                                    ? classes.snackBarSuccess
                                    : classes.snackBarError
                            )}>
                            <Box color='text.primary'>
                                <Typography variant='subtitle1' color='textPrimary'>
                                    {`El porcentaje de participaci\u00F3n de los beneficiarios suma: ${percentageCompleted}%`}
                                </Typography>
                            </Box>
                        </Grid>
                        {AuthorizationCheck}
                    </>
                )}
                <Grid container spacing={2} justifyContent={'space-between'}>
                    {beneficiaries &&
                        beneficiaries.length > 0 &&
                        beneficiaries.map((item: BeneficiaryInfo) => {
                            return (
                                <Grid item xs={12} key={`grid-item-${item.kycId}`}>
                                    <Box
                                        display='flex'
                                        flexDirection='row'
                                        justifyContent='center'
                                        key={`box-${item.kycId}`}>
                                        <Grid item xs={12} key={`grid-item-left-${item.kycId}`}>
                                            <EfeAccordion
                                                values={[
                                                    {
                                                        title: `Beneficiario / ${item.completeName} / ${item.participationPercent}%`,
                                                        icon: <CheckSharp />,
                                                        disabled: false,
                                                        expandIcon: false,
                                                        reactElement: '',
                                                        expanded: false,
                                                    },
                                                ]}
                                                onClick={() => {
                                                    handleChange(item.kycId);
                                                }}
                                            />
                                        </Grid>
                                        <Grid item key={`grid-item-right-${item.kycId}`}>
                                            <IconButton
                                                onClick={() =>
                                                    handleDelete(item.kycId, item.completeName)
                                                }
                                                className={buttonStyles.delete}>
                                                <DeleteForeverIcon color='primary' />
                                            </IconButton>
                                        </Grid>
                                    </Box>
                                </Grid>
                            );
                        })}
                </Grid>
            </Grid>
        </MainContent>
    );
}

export default BeneficiaryHeader;
